/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["genre-widget{display:block;overflow:hidden;text-overflow:ellipsis}genre-widget a{color:inherit}genre-widget a:hover{text-decoration:underline}genre-widget .separator{padding:0 5px}"];
export { styles as styles };
